import { BillingBadge } from "@/components/billing/CycleBilling";
import { money } from "@/components/billing/RateTable";
import { api, formatApiError } from "@/lib/api";
import { todayET } from "@/lib/dates";

export const PayoutList = ({ overview, onChanged, onError }) => {
  async function markPaid(line) {
    try {
      await api.put(`/evaluation-billing/${line.evaluation_id}/billing`, { pay_status: "Paid", provider_paid_on: todayET() });
      onChanged("Provider payment recorded.");
    } catch (requestError) {
      onError(formatApiError(requestError));
    }
  }
  return (
    <section className="compliance-card" data-testid="cycle-payouts">
      <div className="section-heading">
        <div>
          <h3>Evaluation payouts — {overview.cycle_label}</h3>
          <p>Pay providers on {overview.pay_on}. {money(overview.payout_total_owed)} still owed.</p>
        </div>
      </div>
      {["W-2", "1099"].map((group) => (
        <div className="billing-client-block" key={group} data-testid={`payout-group-${group}`}>
          <h4>{group} providers <small>{overview.payouts[group].length} provider(s) · {money(overview.payouts[group].reduce((sum, p) => sum + p.owed, 0))} owed</small></h4>
          {overview.payouts[group].map((provider) => (
            <div className="credential-table-wrap" key={provider.provider_id} data-testid={`payout-provider-${provider.provider_id}`}>
              <table>
                <thead><tr><th>{provider.provider_name}</th><th>Client</th><th>Type</th><th>Provider fee</th><th>Pay status</th><th /></tr></thead>
                <tbody>
                  {provider.lines.map((line) => (
                    <tr key={line.evaluation_id} data-testid={`payout-line-${line.evaluation_id}`}>
                      <td>{line.student_initials}</td>
                      <td>{line.client_name}</td>
                      <td>{line.evaluation_type}</td>
                      <td data-testid={`payout-fee-${line.evaluation_id}`}>{money(line.billing.provider_fee)}</td>
                      <td><BillingBadge value={line.billing.pay_status} testId={`pay-status-${line.evaluation_id}`} />{line.billing.provider_paid_on ? <small> {line.billing.provider_paid_on}</small> : null}</td>
                      <td className="credential-actions">{line.billing.pay_status === "Owed" && <button type="button" className="button button-secondary" data-testid={`mark-provider-paid-${line.evaluation_id}`} onClick={() => markPaid(line)}>Mark paid</button>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
          {!overview.payouts[group].length && <p className="pairing-meta">No {group} payouts in this cycle.</p>}
        </div>
      ))}
    </section>
  );
};

export const LeakageList = ({ leakage }) => (
  <section className="compliance-card" data-testid="billing-leakage">
    <div className="section-heading">
      <div>
        <h3>Leakage check</h3>
        <p>As of {leakage.as_of}: evaluations completed but not invoiced after their bill-by date, and approved reports not yet released to the client.</p>
      </div>
    </div>
    <h4>Completed, not invoiced <small>{leakage.not_invoiced.length}</small></h4>
    <ul className="clearance-packet-list" data-testid="leakage-not-invoiced">
      {leakage.not_invoiced.map((line) => <li key={line.evaluation_id}><div><strong>{line.client_name} · {line.student_initials} · {line.evaluation_type}</strong><small>{money(line.billing.client_fee)} · {line.billing.cycle_label} cycle · bill by {line.billing.bill_by}</small></div></li>)}
      {!leakage.not_invoiced.length && <li><small>Nothing outstanding.</small></li>}
    </ul>
    <h4>Approved reports not released <small>{leakage.not_released.length}</small></h4>
    <ul className="clearance-packet-list" data-testid="leakage-not-released">
      {leakage.not_released.map((line) => <li key={line.evaluation_id}><div><strong>{line.client_name} · {line.student_initials} · {line.evaluation_type}</strong><small>Completed {(line.completed_at || "").slice(0, 10)} · release it from Evaluation review</small></div></li>)}
      {!leakage.not_released.length && <li><small>Every completed report has been released.</small></li>}
    </ul>
  </section>
);
